module.exports = __webpack_public_path__ + "img/TERMVET-logo-white.57b0c470.svg";